/**
 * Long-form text wrapper. Constrains width, sets readable line-height,
 * and styles headings in cyan. Used by /terms and /privacy.
 */

import React from 'react';

interface MarkdownContentProps {
  children: React.ReactNode;
  maxWidth?: number;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ children, maxWidth = 720 }) => (
  <article className="gv-markdown" style={{ maxWidth, margin: '0 auto', padding: '0 1.5rem' }}>
    {children}
  </article>
);

export default MarkdownContent;
